import React from 'react';
import styled from 'styled-components';
import { styles } from '@utils';

function LegalFooter() {
  return (
    <Container>
      <span>
        ©{new Date().getFullYear()}
        <a
          href="https://www.radiosystemscorporation.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Radio Systems Corporation
        </a>
        <span>All Rights Reserved.</span>
        <a
          href="https://www.sportdog.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Statement
        </a>
        <a
          href="https://www.sportdog.com/support/terms-and-conditions/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms &amp; Conditions
        </a>
      </span>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem 1rem 4rem;
  text-transform: uppercase;
  color: ${styles.colors.gray[400]};
  font-size: 0.875rem;
  margin-top: 3rem;

  a,
  span {
    padding-left: 0.5rem;
  }

  a {
    color: ${styles.colors.gray[400]};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export default LegalFooter;
